export default {
  error: (state) => state.error,
  isLoading: (state) => state.isLoading,
  isAdding: (state) => state.isAdding,
  isHandling: (state) => state.isHandling,
  isRefreshing: (state) => state.isRefreshing,
  detail: (state) => state.detail,
  roles: (state) => state.roles,
  users: (state) => state.users,
  cursor: (state) =>
    state.paging && state.paging.next_cursor ? state.paging.next_cursor : null,
  total: (state) =>
    state.paging && state.paging.total_count ? state.paging.total_count : 0,
};
